import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phone'
})
export class PhonePipe implements PipeTransform {
    transform(value: string): string {
      // Lógica para formatear el número de teléfono en formato US
      if (value && value.length === 10) {
        return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
      }
      return value;
    }
}

